import { Box, Flex, Text } from '@chakra-ui/react';

interface DesktopSidebarNavItemProps {
  icon: React.ElementType;
  label: string;
  isActive?: boolean;
  onClick: () => void;
  isSubItem?: boolean;
}

export default function DesktopSidebarNavItem({
  icon: IconComponent,
  label,
  isActive = false,
  onClick,
  isSubItem = false,
}: DesktopSidebarNavItemProps) {
  return (
    <Flex
      as="button"
      align="center"
      gap={2.5}
      w="100%"
      px={isSubItem ? '30px' : 3}
      py={isSubItem ? '6px' : '9px'}
      borderRadius="8px"
      borderLeft="3px solid"
      borderLeftColor={isActive ? 'accent.secondary' : 'transparent'}
      bg={isActive ? 'accent.secondarySubtle' : 'transparent'}
      color={isActive ? 'accent.secondary' : 'text.primary'}
      fontFamily="body"
      fontWeight={isActive ? '600' : '400'}
      fontSize={isSubItem ? '13px' : '14px'}
      cursor="pointer"
      textAlign="left"
      transition="background 0.12s, color 0.12s"
      _hover={{
        bg: isActive ? 'accent.secondarySubtle' : 'bg.muted',
        color: isActive ? 'accent.secondary' : 'text.primary',
      }}
      onClick={onClick}
      aria-current={isActive ? 'page' : undefined}
    >
      {!isSubItem && (
        <Box color={isActive ? 'accent.secondary' : 'text.muted'} flexShrink={0} lineHeight={0}>
          <IconComponent size={19} />
        </Box>
      )}
      {isSubItem && (
        <Box
          w="5px"
          h="5px"
          borderRadius="full"
          bg={isActive ? 'accent.secondary' : 'border.muted'}
          flexShrink={0}
          mt="1px"
        />
      )}
      <Text truncate>{label}</Text>
    </Flex>
  );
}
